/**
 * Product card gallery
 */
(function () {
  function showSlide(card, index) {
    var slides = card.querySelectorAll(".t-card__img");
    if (!slides.length) return;
    var i = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach(function (img, n) {
      img.classList.toggle("is-active", n === i);
    });
    card.dataset.tCardIndex = String(i);
  }

  document.addEventListener("click", function (e) {
    var prev = e.target.closest("[data-t-card-prev]");
    var next = e.target.closest("[data-t-card-next]");
    if (!prev && !next) return;

    e.preventDefault();
    e.stopPropagation();

    var card = e.target.closest("[data-t-card]");
    if (!card) return;

    var current = parseInt(card.dataset.tCardIndex || "0", 10) || 0;
    showSlide(card, current + (next ? 1 : -1));
  });
})();

/* Editorial manifesto CTA + mid-hero placeholder */
(function () {
  function flattenEditorial() {
    document.querySelectorAll(".t-editorial, .t-manifesto").forEach(function (root) {
      var copy = root.querySelector(".t-editorial__copy, .t-manifesto__copy");
      if (!copy) {
        var intro = root.querySelector(".t-editorial__intro, .t-manifesto__inner");
        if (intro) {
          var ctaKeep = intro.querySelector("a");
          var plain = (intro.innerText || "").replace(/\s+/g, " ").trim();
          if (ctaKeep) plain = plain.replace(/\s*Conocer más\s*$/i, "").trim();
          var p = document.createElement("p");
          p.className = "t-editorial__copy";
          p.textContent = plain;
          intro.innerHTML = "";
          intro.appendChild(p);
          if (ctaKeep) intro.appendChild(ctaKeep);
          copy = p;
        }
      }
      if (copy) {
        copy.textContent = (copy.innerText || "")
          .replace(/[^\S\n]+/g, " ")
          .replace(/[ \t]*\n[ \t]*/g, "\n")
          .trim();
        copy.style.setProperty("text-align", "left", "important");
        copy.style.setProperty("white-space", "pre-line", "important");
        copy.style.setProperty("max-width", "42rem", "important");
      }
      var cta = root.querySelector(".t-editorial__cta, .t-manifesto__cta");
      if (cta) {
        cta.style.setProperty("display", "block", "important");
        cta.style.setProperty("margin", "3rem auto 0", "important");
        cta.style.setProperty("width", "fit-content", "important");
        cta.style.setProperty("border", "0", "important");
        cta.style.setProperty("background", "none", "important");
        cta.style.setProperty("font-weight", "700", "important");
      }
    });
  }

  function enhanceEditorial() {
    var intro = document.querySelector(".t-editorial__intro");
    if (intro && !intro.querySelector(".t-editorial__cta")) {
      var cta = document.createElement("a");
      cta.className = "t-editorial__cta";
      cta.href = "/pages/about";
      cta.textContent = "Conocer más";
      intro.appendChild(cta);
    }
    flattenEditorial();
  }

  function ensureMidHero() {
    if (document.querySelector(".t-mid-hero")) return;
    var editorial = document.querySelector(".t-editorial, .t-manifesto");
    if (!editorial || !editorial.parentElement) return;
    var wrap = document.createElement("div");
    wrap.className = "shopify-section t-full";
    wrap.innerHTML =
      '<section class="t-mid-hero full-width"><div class="t-mid-hero__link"><div class="t-mid-hero__ph"><span>Imagen hero — súbela en el editor (sección Home mid hero)</span></div></div></section>';
    editorial.parentElement.insertAdjacentElement("afterend", wrap);
  }

  function run() {
    enhanceEditorial();
    ensureMidHero();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  document.addEventListener("shopify:section:load", run);
  setTimeout(run, 400);
})();
